module.exports = __webpack_public_path__ + "img/arrows-road.430a648.jpg";